export default function (planbookId, userId, verb = "edited") {
  return {
    actor: `user-${userId}`,
    verb: verb,
    object: `planbook-${planbookId}`,
    to: [`planbook-edits:planbook-${planbookId}`],
  }
}
